// Long-form text content for all pages — sourced from the specification document

export const ABOUT_PAGE = {
  paragraph1: `PropInvest\u2122 specialises in <strong class="text-primary font-semibold">EXCLUSIVE PROPERTY INVESTMENTS</strong> not available to the public, while equipping South Africans with the <strong class="text-primary font-semibold">EDUCATION</strong> and <strong class="text-primary font-semibold">TOOLS</strong> to achieve <strong class="text-primary font-semibold">FINANCIAL FREEDOM</strong> and build <strong class="text-primary font-semibold">GENERATIONAL WEALTH.</strong> With over 20,000 property investments <strong class="text-primary font-semibold">SOLD</strong> over the last 20+ years, we've helped investors of all levels <strong class="text-primary font-semibold">CREATE WEALTH</strong> for themselves and their families.`,

  paragraph2: `We offer <strong class="text-primary font-semibold">FREE RESOURCES</strong> to guide you on your property investment journey, including tips on asset protection and <strong class="text-primary font-semibold">SAVING MONEY</strong>. Many of our clients started with just one property and have since expanded their portfolios. We're with you every step of the way, helping you reach your <strong class="text-primary font-semibold">FINANCIAL GOALS.</strong>`,

  empoweringLegacies: `As a proudly South African company, we've helped thousands of locals become <strong class="text-primary font-semibold">FINANCIALLY FREE</strong>. Our loyal clients rave about our service, reflected in our excellent online reviews and high trust score. Let our <strong class="text-primary font-semibold">EXPERT CONSULTANTS</strong> help you build your <strong class="text-primary font-semibold">FINANCIAL FUTURE TODAY.</strong>`,

  pillars: ['PASSION', 'RESPECT', 'ORIGINALITY', 'PROFESSIONAL', 'INTEGRITY', 'NOTABLE', 'VALUES', 'ETHICAL', 'STRENGTH', 'TRUST'] as const,

  missionStatement: `PropInvest\u2122 aims to create a lasting impact by fostering a culture of inclusivity, sustainability, and innovation. We strive to <strong class="text-primary font-semibold">INSPIRE</strong> and <strong class="text-primary font-semibold">EMPOWER</strong> individuals, communities, and organizations to <strong class="text-primary font-semibold">BUILD LEGACIES</strong> that transcend generations.`,
};

export const HOME_PAGE = {
  // Wealth-strategy band (2026-09-18) — replaced "All the services you need".
  // The button scrolls to the strategy form in the section directly below
  // (`#summary-form`); a route path also works here.
  strategy: {
    heading: 'FREE, CUSTOM WEALTH CREATION STRATEGY',
    subtext: 'Get Access Now!',
    link: '#summary-form',
  },
  // Legacy keys — no longer rendered on the home page (the "Why invest"
  // text column became the Millionaire Strategy form). Kept so saved CMS
  // docs and the admin editor's types still line up.
  whyInvest: {
    heading: 'WHY INVEST IN PROPERTY',
    subtext: 'You can Buy Property Using the Bank\'s Money.',
    link: '/education',
  },
  allServices: {
    heading: 'ALL THE SERVICES YOU NEED',
    subtext: 'Everything Property, Under One Roof',
    link: '/services',
  },
};

export const CAREERS_PAGE = {
  intro: 'Join a team that makes a significant and transformative difference in people\'s lives.',
  heading: 'WE ARE ALWAYS SEARCHING FOR LIKE-MINDED INDIVIDUALS!',
  bannerHeading: 'Join the PropInvest team',

  // Jaco 2026-10-14. paragraph2 holds the 2nd and 3rd paragraphs (CMS has two slots).
  paragraph1: `PropInvest\u2122 has been the leader in exclusive property investments since 2002 and is rated 4.9 stars with a 9.1 Trust Index on HelloPeter, the strongest review record in Property Investment. We identify off-market developments with strong rental yields and capital growth potential, and we provide the analysis, education and support that enable clients to invest with clarity and confidence. Our work is focused on helping clients build sustainable property portfolios over time.`,

  paragraph2: `<p>We seek professionals who share this commitment to long-term client outcomes. Every role contributes meaningfully to the delivery of well-considered investment solutions and the ongoing support that clients require. We place equal emphasis on the development of our people, providing structured opportunities to deepen expertise and expand capability within a disciplined and collaborative environment.</p><p class="mt-4">If you are seeking a role in which professional standards, client results and individual growth are treated as integral to the business, we invite you to explore opportunities with PropInvest.</p>`,

  readyHeading: 'READY TO JOIN THE MOVEMENT?',
  questions: [
    'Are <strong class="text-primary font-semibold">YOU</strong> goal and target driven?',
    'Do <strong class="text-primary font-semibold">YOU</strong> have a passion for people and property?',
    'Are <strong class="text-primary font-semibold">YOU</strong> willing to learn?',
  ],
};

export const CONTACT_PAGE = {
  getInTouch: {
    heading: 'GET IN TOUCH',
    text: 'Every investor is unique, which is why our consultants build a strategy around your specific needs and aspirations. Whether you\'re a first-time buyer or an experienced investor, we work closely with you to develop a plan that maximises your potential while minimising risks. Reach out to us today for professional assistance.',
  },
  formHeading: 'ASK US A QUESTION',
  hoursHeading: 'BUSINESS HOURS',
};

export const CONSULTATION_PAGE = {
  heading: 'EXPERT ADVICE, JUST A CLICK AWAY',
  text: 'Booking a consultation is an essential move for anyone thinking about investing in property. This step gives clients the knowledge and resources they need to navigate the challenges of property investment and maximise their potential profits.',
};

export const SERVICES_PAGE = {
  videoHeading: 'COMPREHENSIVE SERVICES TAILORED FOR PROPERTY INVESTMENT',
  buttonsHeading: 'EVERYTHING PROPERTY UNDER ONE ROOF',
};

export const BEGINNERS_PAGE = {
  videoHeading: 'PROPERTY INVESTMENT BEGINNERS GUIDE SERIES',
  formHeading: 'REQUEST A CALLBACK FROM AN EXPERT',
  formSubtext: 'Let us give you a call. Choose a date and time that works for you and one of our property investment experts will reach out.',
};

export const TOOLS_PAGE = {
  heading: 'THE ULTIMATE TOOLKIT',
};

export const PROPERTY_PAGE = {
  recentHeading: 'EXPLORE OUR MOST RECENT PROPERTY INVESTMENT OPPORTUNITIES',
  regionalHeading: 'EXPLORE REGIONAL PROPERTY INVESTMENT OPTIONS',
  ctaHeading: 'STARTING YOUR INVESTMENT JOURNEY? LET\'S TAKE THE FIRST STEP TOGETHER.',
};

// Service sub-page content
export const SERVICE_PAGES = {
  refinance: {
    title: 'Home Loans',
    heading: 'HOME LOANS',
    h1Text: 'Home Loans',
    metaTitle: 'Home Loans | PropInvest South Africa',
    description: 'Secure the right home loan for your investment. Our bond specialists work with multiple banks to compare offers and secure the best rates and terms for your situation.',
    metaDescription: 'Home loans and bond finance in South Africa made simple. Compare multiple bank offers and secure the best rates and terms with PropInvest\'s expert home loan service.',
    benefits: [
      'Access equity for new investments',
      'Potentially lower your monthly repayments',
      'Consolidate debt at better interest rates',
      'Fund property improvements or renovations',
      'Expert guidance through the entire process',
    ],
  },
  resales: {
    title: 'Re-sell a Property',
    heading: 'RE-SELL YOUR PROPERTY',
    h1Text: 'Investment Property Resales',
    metaTitle: 'Investment Property Resales in South Africa | PropInvest',
    description: 'Looking to sell your investment property? Our experienced team handles the entire resale process, from valuation to transfer, ensuring you get the best possible return on your investment.',
    metaDescription: 'Sell your property investment in South Africa with PropInvest. Expert valuations, investor network marketing and full transfer management for maximum returns.',
    benefits: [
      'Professional property valuation',
      'Marketing to our extensive investor network',
      'Negotiation expertise',
      'Full transfer management',
      'Maximise your return on investment',
    ],
  },
  rentals: {
    title: 'Find a Tenant',
    heading: 'RENTAL MANAGEMENT',
    h1Text: 'Rental Investment Properties in South Africa',
    metaTitle: 'Rental Investment Properties South Africa | PropInvest',
    description: 'Let us handle the complexities of property rentals. From finding quality tenants to managing your rental portfolio, we provide a comprehensive service that maximises your rental income while minimising hassle.',
    metaDescription: 'Rental property management in South Africa. PropInvest handles tenant screening, lease management, rent collection and maintenance for hassle-free income.',
    benefits: [
      'Thorough tenant screening and vetting',
      'Competitive rental pricing analysis',
      'Lease agreement management',
      'Rent collection and arrears management',
      'Property maintenance coordination',
    ],
  },
  trustee: {
    title: 'Independent Trustee',
    heading: 'INDEPENDENT TRUSTEE SERVICES',
    h1Text: 'Independent Trustee Services for Property Investors',
    metaTitle: 'Independent Trustee Services for Investors | PropInvest',
    description: 'Protect your assets with professional trustee services. An independent trustee ensures your trust is managed ethically and in accordance with the Trust Property Control Act, safeguarding your wealth for future generations.',
    metaDescription: 'Independent trustee services in South Africa. Ensure ethical trust management, legal compliance and asset protection with PropInvest\'s professional trustees.',
    benefits: [
      'Objective oversight of trust administration',
      'Compliance with legal requirements',
      'Protection of beneficiary interests',
      'Professional asset management guidance',
      'Regular reporting and transparency',
    ],
  },
  insurance: {
    title: 'Insurance',
    heading: 'PROPERTY INSURANCE',
    h1Text: 'Property Insurance Solutions for Investors',
    metaTitle: 'Property Insurance for Investors | PropInvest South Africa',
    description: 'Protect your investment with comprehensive property insurance solutions. We work with leading insurers to provide cover tailored to property investors, ensuring your assets are protected against unforeseen events.',
    metaDescription: 'Property insurance for South African investors. PropInvest offers building, contents, rental loss and liability cover from leading insurers.',
    benefits: [
      'Building and contents insurance',
      'Rental loss protection',
      'Legal liability cover',
      'Natural disaster protection',
      'Competitive premiums from top insurers',
    ],
  },
  capitalInvestment: {
    title: 'Capital Investment Opportunity',
    heading: 'CAPITAL INVESTMENT OPPORTUNITY',
    metaTitle: 'Capital Investment | PropInvest™',
    description: 'Discover unique capital investment opportunities that offer attractive returns. Whether you\'re looking for passive income or capital growth, our investment team identifies opportunities that align with your financial goals.',
    metaDescription: 'Capital investment opportunities in South African property. Earn attractive returns through vetted investments with expert guidance from PropInvest.',
    benefits: [
      'Carefully vetted investment opportunities',
      'Attractive potential returns',
      'Diversify your investment portfolio',
      'Expert guidance and ongoing support',
      'Transparent reporting and communication',
    ],
  },
  trustCreation: {
    title: 'Trust Creation',
    heading: 'TRUST CREATION',
    description: 'Protect your wealth and create a lasting legacy with a professionally structured trust. Our trust creation service guides you through every step, from choosing the right trust type to registration with the Master of the High Court, ensuring your assets are safeguarded for future generations.',
    metaDescription: 'Trust creation for property investment in South Africa. PropInvest handles trust structuring, deed drafting and High Court registration to protect your wealth.',
    benefits: [
      'Asset protection from creditors and litigation',
      'Estate duty and tax planning advantages',
      'Ensure continuity of wealth across generations',
      'Professional drafting of trust deeds',
      'Full registration with the Master of the High Court',
    ],
  },
  companyRegistration: {
    title: 'Register a Company (PTY)',
    heading: 'REGISTER A COMPANY (PTY) LTD',
    description: 'Start your business on the right footing with a properly registered private company. We handle the complete CIPC registration process, from name reservations to tax registrations, so you can focus on building your business and growing your property portfolio.',
    metaDescription: 'Company registration for property investment in South Africa. PropInvest handles CIPC registration, tax numbers and compliance for your PTY Ltd.',
    benefits: [
      'Complete CIPC company registration',
      'Name reservation and availability checks',
      'Tax number and VAT registration assistance',
      'Company documentation and compliance packs',
      'Ideal structure for property investment holdings',
    ],
  },
  wills: {
    title: 'Will and Testaments',
    heading: 'WILL AND TESTAMENTS',
    description: 'Ensure your wishes are honoured and your loved ones are protected with a professionally drafted will. Our service covers everything from simple wills to complex estate plans, making sure your property investments and assets are distributed exactly as you intend.',
    metaDescription: 'Wills and estate planning for property investors in South Africa. Professionally drafted wills to protect your investments and provide for your loved ones.',
    benefits: [
      'Professionally drafted and legally compliant wills',
      'Protection for your property investment portfolio',
      'Nomination of guardians for minor children',
      'Clear instructions for asset distribution',
      'Regular review and updates as your estate grows',
    ],
  },
} as const;
